import React, { useState } from 'react';
import Navbar from './Navbar';
import '../styles.css';

function Contact() {
  const [formData, setFormData] = useState({ fullName: '', email: '', phone: '', question: '' });

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent('Contact Form Submission from Casalytix');
    const body = encodeURIComponent(
      `Full Name: ${formData.fullName}\nEmail: ${formData.email}\nPhone: ${formData.phone}\nQuestion/Concern: ${formData.question}`
    );
    window.location.href = `mailto:casalytix@gmail.com?subject=${subject}&body=${body}`;
    setFormData({ fullName: '', email: '', phone: '', question: '' });
  };

  return (
    <div>
      <Navbar />
      <main className="main-content">
        <section className="auth-container">
          <div className="form-container">
            <h2>Contact Us</h2>
            <form id="contact-form" onSubmit={handleSubmit}>
              <label htmlFor="full-name">Full Name</label>
              <input
                type="text"
                id="full-name"
                name="full-name"
                value={formData.fullName}
                onChange={(e) => setFormData({ ...formData, fullName: e.target.value })}
                required
              />
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                required
              />
              <label htmlFor="phone-number">Phone Number</label>
              <input
                type="tel"
                id="phone-number"
                name="phone-number"
                value={formData.phone}
                onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                required
              />
              <label htmlFor="question">Question/Concern</label>
              <textarea
                id="question"
                name="question"
                rows="4"
                value={formData.question}
                onChange={(e) => setFormData({ ...formData, question: e.target.value })}
                required
              />
              <button type="submit">Submit</button>
            </form>
          </div>
        </section>
      </main>
      <footer className="footer">
        <p>
          © 2025 Casalytix. All rights reserved. | <a href="/privacy-policy" className="footer-link">Privacy Policy</a>
        </p>
      </footer>
    </div>
  );
}

export default Contact;